import {
  Component,
  TemplateRef,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { PhxCardWidth } from './phx-card-base.types';

@Component({
  selector: 'phx-card-base',
  templateUrl: './phx-card-base.component.html',
  styleUrls: ['./phx-card-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-card-base',
    '[class.phx-has-shadow]': `phxHasShadow`,
    '[class.phx-default-width]': `phxWidth === 'default'`,
    '[class.phx-full-width]': `phxWidth === 'full'`,
  },
})
export class PhxCardBaseComponent {
  @Input() public phxHeader: TemplateRef<any>;
  @Input() public phxBody: TemplateRef<any>;
  @Input() public phxHasShadow: boolean = true;
  @Input() public phxWidth: PhxCardWidth = 'default';

  constructor() { }

}
